import { InviteLinkRole, InviteLinkType } from "libs/apiClient";
import { DiscoverRoleChoices } from "features/discover/types";
import apiURL from "libs/apiUrl";
import userPlaceholder from "assets/images/user-placeholder.png";

export function formatDate(dateValue: string | null | undefined) {
	return typeof dateValue === "string"
		? new Intl.DateTimeFormat("en-GB", {
			dateStyle: "short",
		}).format(new Date(dateValue))
		: "-";
}

export function formatDateTime(dateValue: string | null, birthday = false) {
	return typeof dateValue === "string"
		? new Intl.DateTimeFormat("en-GB", {
			dateStyle: "short",
			timeStyle: "short",
		}).format(new Date(dateValue))
		: "-";
}

export function getInviteLinkRoleLabel(role: InviteLinkRole | null): string | null {
	if (role === "club_house_admin") {
		return "Clubhouse Admin";
	}
	if (role === "club_house_member") {
		return "Clubhouse Member";
	}
	if (role === "team_admin") {
		return "Team Admin";
	}
	if (role === "team_member") {
		return "Team Member";
	}

	return null;
}

export function getInviteLinkTypeLabel(role: InviteLinkType | null): string | null {
	if (role === "club_house_team") {
		return "Join clubhouse as a team";
	}
	if (role === "club_house_member") {
		return "Join clubhouse as a member";
	}
	if (role === "team_member") {
		return "Join team as a member";
	}

	return null;
}

export function translateDiscoverRole(role: string | null): string | null {
	return DiscoverRoleChoices.find((c) => c.value === role)?.label || null;
}

export function createSortArrows(columnName: string, sort?: { field: string, direction: string } | undefined, onChange?: ((sort?: { field: string, direction: string }) => void)) {
	const handleSort = (direction: string) => {
		if (!onChange) {
			return;
		}

		if (columnName === sort?.field && sort?.direction === direction) {
			onChange(undefined);
		} else {
			onChange({ field: columnName, direction: direction });
		}
	}

	return (
		<div className="sortArrows">
			<span className={`icon-new icon-16 icon-select-arrow-down up ${sort?.field === columnName && sort.direction === "ASC" ? 'is-active' : ''}`} onClick={() => handleSort("ASC")} />
			<span className={`icon-new icon-16 icon-select-arrow-down down ${sort?.field === columnName && sort.direction === "DESC" ? 'is-active' : ''}`} onClick={() => handleSort("DESC")} />
		</div>
	)
}

export function humanizeLabel(label: string): string {
	return label
		.replace(/([A-Z])/g, " $1")
		.replace(/^./, (str) => str.toUpperCase());
}

export const ucFirst = (string: string | null | undefined): string | null => {
	if (!string) {
		return null;
	}

	return string.charAt(0).toUpperCase() + string.slice(1);
}

export function resolveProfilePhotoSrc(photo?: string | null): string {
	if (!photo || photo.trim() === "") {
		return userPlaceholder;
	}
	if (photo.includes("http")) {
		return photo;
	}
	return `${apiURL}/${photo.replace(/^\//, "")}`;
}
